import React from "react";
import {
  ScatterChart,
  Scatter,
  XAxis,
  YAxis,
  ZAxis,
  LabelList,
  Cell,
  ResponsiveContainer,
} from "recharts";

// Data for extra bubbles
const extraBubbles = [
  { x: 50, y: 90, z: 0.5, name: "", opacity: 0.4 },
  { x: 70, y: 105, z: 1.8, name: "", opacity: 0.2 },
  { x: 110, y: 45, z: 2.2, name: "", opacity: 0.2 },
  { x: 140, y: 30, z: 1.4, name: "", opacity: 0.2 },
  { x: 180, y: 130, z: 2.2, name: "", opacity: 0.4 },
  { x: 200, y: 100, z: 1.5, name: "", opacity: 0.3},
  { x: 90, y: 200, z: 1.9, name: "", opacity: 0.3 },
  { x: 120, y: 180, z: 3.2, name: "", opacity: 0.4 },
];

const BubbleChart = ({ data: chartData }) => {

  const truncateText = (text, rank) => {
    let maxLength = 10; // Adjusted to a fixed length for simplicity
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };

  // Function to calculate opacity based on rank
  const calculateOpacity = (rank) => {
    const opacityMap = {
      1: 1.0,
      2: 0.9,
      3: 0.8,
      4: 0.7,
      5: 0.5,
    };
    return opacityMap[rank] || 0.2; // Default opacity if rank not found
  };

  // Define positions for each rank
  const predefinedPositions = [
    { x: 120, y: 120 }, // Rank 5
    { x: 55, y: 165 },  // Rank 2
    { x: 165, y: 175 }, // Rank 3
    { x: 65, y: 45 },   // Rank 4
    { x: 165, y: 55 },  // Rank 1
  ];

  // Process main data
  const updatedData = chartData.map((chartItem, index) => ({
    x: predefinedPositions[index]?.x || 0,
    y: predefinedPositions[index]?.y || 0,
    z: chartItem.percentage, // Adjust bubble size based on percentage
    name: truncateText(chartItem.name, chartItem.rank),
    percentage: chartItem.percentage,
    opacity: calculateOpacity(chartItem.rank), // Set opacity based on rank
  }));

  // Combine main data with extra bubbles
  const combinedData = [...updatedData, ...extraBubbles];

  return (
    <ResponsiveContainer height={200}>
      <ScatterChart
        margin={{
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <XAxis
          type="number"
          domain={[0, 210]}
          dataKey="x"
          name="x"
          unit="cm"
          tick={false}
          axisLine={false}
          height={5}
        />
        <YAxis
          type="number"
          domain={[0, 210]}
          dataKey="y"
          name="y"
          unit="cm"
          tick={false}
          axisLine={false}
          width={5}
        />
        <ZAxis type="number" dataKey="z" range={[0, 5000]} name="z" unit="km" />
        <Scatter name="A school" data={combinedData} shape="circle">
          <LabelList
            dataKey={"percentage"}
            position="top"
            style={{ fill: "white", fontSize: "0.6rem", fontWeight: 600 }}
            offset={-20} // Adjust position to ensure it's above the name
          /> 
          <LabelList
            dataKey="name"
            position="inside"
            style={{ fill: "white", fontSize: "0.5rem", fontWeight: 600 }}
            offset={10} // Adjust position to ensure it's below the percentage
          />
          {combinedData.map(({ opacity }, index) => (
            <Cell
              key={`cell-${index}`}
              fill="#4361EE"
              style={{
                opacity: opacity,
                filter: "drop-shadow(0 0 2px #4361EE)",
              }}
            />
          ))}
        </Scatter>
      </ScatterChart>
    </ResponsiveContainer>
  );
};

export default BubbleChart;
